module.exports = __webpack_public_path__ + "assets/img/familyCrest-d112fb2a.png";